﻿const allMediaQuery = window.matchMedia("(min-width: 0px)");
const mobileMediaQuery = window.matchMedia("(max-width: 768px)");

declare const UIkit: any;
const maxNavDots = 7; // Must be uneven. I.e. '7' = active dot with 3 more on each side for 7 total.

class SliderOptions
{
    mobileOnly?: boolean = true;
    desktopOnly?: boolean = false;
    maxRes?: number;
    itemsMobile?: number;
    itemsDesktop?: number;
    center?: boolean = false;
    finite?: boolean = false;
    autoplay?: boolean = false;
    dotNav?: boolean;

    constructor(init?: Partial<SliderOptions>)
    {
        if (init)
        {
            for (const key of Object.keys(init) as Array<keyof SliderOptions>)
            {
                if (init[key] !== undefined && init[key] !== null)
                    (this as Record<string, any>)[key] = init[key] as any;
            }
        }
    }
}

export const initSlider = (sliderHolder: HTMLElement, options: SliderOptions) =>
{
    const slider = sliderHolder.querySelector("ul");

    if (sliderHolder && slider)
    {
        let sliderInstance: any = null;

        let mobileWidthClass = "";

        if (options.mobileOnly ||
            options.itemsMobile > 0
        )
            mobileWidthClass = `uk-child-width-1-${options.itemsMobile ?? 1}`;

        const handleBreakpointChange = (e: MediaQueryListEvent | MediaQueryList) =>
        {
            // Add slider for mobile.
            if (e.matches)
            {
                sliderHolder.classList.add("uk-slider-container");
                slider.classList.add("uk-slider-items");

                if (mobileWidthClass.length > 0)
                    slider.classList.add(mobileWidthClass);

                requestAnimationFrame(() =>
                {
                    UIkit.update(sliderHolder);

                    if (!sliderInstance)
                    {
                        sliderInstance = UIkit.slider(
                            sliderHolder,
                            {
                                center: options.center,
                                autoplay: options.autoplay,
                                autoplayInterval: 5000,
                                finite: options.finite,
                                draggable: true,
                                active: "all"
                            }
                        );
                    }

                    if (options.dotNav)
                        new dotNavSlider(null, sliderHolder);
                });
            }
            // Remove slider for desktop.
            else
            {
                if (sliderInstance)
                {
                    sliderInstance.$destroy(false);
                    sliderInstance = null;
                }

                sliderHolder.classList.remove("uk-slider-container", "uk-slider");
                slider.classList.remove("uk-slider-items");

                if (mobileWidthClass.length > 0)
                    slider.classList.remove(mobileWidthClass);

                slider.removeAttribute("style");
                Array.from(slider.children).forEach(child =>
                {
                    child.removeAttribute("style");
                    child.classList.remove("uk-active");
                });

                UIkit.update(sliderHolder);
            }
        };

        let mediaQueryThreshold = allMediaQuery;

        if (options.maxRes > 0)
            mediaQueryThreshold = window.matchMedia(`(max-width: ${options.maxRes}px)`);
        else if (options.mobileOnly)
            mediaQueryThreshold = mobileMediaQuery;

        mediaQueryThreshold.addEventListener("change", handleBreakpointChange);

        // Run once after page load.
        handleBreakpointChange(mediaQueryThreshold);
    }
}

document.addEventListener("DOMContentLoaded", (): void =>
{
    reInitSlider();
});

export const reInitSlider = () =>
{
    $(".c-slider").each(function ()
    {
        const sliderHolder = $(this)[0];

        let mobileOnly = null;
        let desktopOnly = null;
        const maxRes = $(this).data("slider-max-res") ?? null;

        if ($(this).data("slider-mobile-only") != null)
        {
            mobileOnly =
                $(this).data("slider-mobile-only") === "true" ||
                $(this).data("slider-mobile-only") === true;
        }

        if ($(this).data("slider-desktop-only") != null) {
            desktopOnly =
                $(this).data("slider-desktop-only") === "true" ||
                $(this).data("slider-desktop-only") === true;
        }

        if (maxRes > 0)
            mobileOnly = false;

        const options = new SliderOptions({
            mobileOnly: mobileOnly ?? undefined,
            desktopOnly: desktopOnly ?? undefined,
            maxRes: maxRes ?? undefined,
            itemsMobile: $(this).data("slider-items-mobile") ?? undefined,
            itemsDesktop: $(this).data("slider-items-desktop") ?? undefined,
            center: $(this).data("slider-center") ?? undefined,
            finite: $(this).data("slider-finite") ?? undefined,
            autoplay: $(this).data("slider-autoplay") ?? undefined,
            dotNav: $(this).data("slider-dotnav") ?? undefined
        });

        initSlider(sliderHolder, options);
    });

    initSliderDotNavEvents();
};

class dotNavSlider
{
    private wrapper: HTMLElement;
    private dotNav: HTMLElement;

    constructor(dotNavHolder?: HTMLElement, slider?: HTMLElement)
    {
        if (slider && !dotNavHolder)
            dotNavHolder = slider.querySelector(".c-overflow-nav__holder") as HTMLElement;

        // For sliders with many dots in their dotnav, center the selected one and only show a few on each side.   
        if (slider && !dotNavHolder)
        {
            // Get all items.
            const items = slider.querySelectorAll("li");
            let itemCounter = 0;

            if (items.length > 1)
            {
                // Create new slider.
                const navHolder = document.createElement("div");
                navHolder.className = "c-overflow-nav__holder";

                const ul = document.createElement("ul");
                ul.className = "uk-slider-nav uk-dotnav uk-margin nolist c-overflow-nav__list";

                items.forEach((item: HTMLElement) =>
                {
                    const li = document.createElement("li");
                    li.setAttribute("uk-slider-item", itemCounter.toString());
                    li.setAttribute("role", "presentation");

                    const anchor = document.createElement("a");
                    anchor.href = "";
                    li.appendChild(anchor);

                    ul.appendChild(li);
                    itemCounter++;
                });

                navHolder.appendChild(ul);
                slider.appendChild(navHolder);

                this.wrapper = navHolder;
                this.dotNav = ul;
            }
        }
        else if (dotNavHolder)
        {
            this.wrapper = dotNavHolder;
            this.dotNav = dotNavHolder.querySelector<HTMLUListElement>(".uk-dotnav.c-overflow-nav__list");
        }

        if (dotNavHolder)
        {
            if ($(this.dotNav).has("[hidden]").length > 0)
                dotNavHolder.setAttribute("hidden", "hidden");
            else
                dotNavHolder.removeAttribute("hidden");
        }

        if (this.wrapper && this.dotNav)
        {
            const defaultDotWidth = 6;

            const shiftDotnav = (index: number): void =>
            {
                let activeDot = this.dotNav.children[index] as HTMLElement;

                if (activeDot &&
                    // Only dynamically slide dotNav items along if there are too many to show normally.
                    this.dotNav.children.length > maxNavDots)
                {
                    // Use the offsetWidth of the real active dot, even if it gets overwritten, because active dot styling may be wider than inactive dots.
                    const offsetWidth = (activeDot.offsetWidth / 2);

                    // The max. index of the slider.
                    const maxIndex = this.dotNav.children.length - 1;

                    // The max. allowed index of the slider that's used to determine how to translate it. (See below.)
                    const maxAllowedIndex = (maxIndex - ((maxNavDots - 1) / 2));

                    // Below check ensure that if for example 'maxNavDots' is 7, and the second-last item is selected...
                    // That we see this: 'o o o o o X o' (7 dots)
                    // Instead of this: o o o X o (less than 7 dots)
                    // Because 'maxNavDots' amount of dots should always show.
                    // And the active dot should only be centered if both sides will have equal amount of inactive dots.
                    if (index > maxAllowedIndex)
                        activeDot = this.dotNav.children[maxAllowedIndex] as HTMLElement;

                    // Get center position of the dot that should be centered.
                    const dotCenter = activeDot.offsetLeft + offsetWidth;

                    // Get width of the dotnav list.
                    const wrapperWidth = this.wrapper.offsetWidth;

                    // Get exact center of dotnav list.
                    const containerCenter = wrapperWidth / 2;

                    const expansionOffset = (activeDot.offsetWidth - defaultDotWidth);
                    let translateX: number = containerCenter - dotCenter;

                    // Don't slide dotnav list such that less than 'maxNavDots' are shown.
                    // I.e. if 'maxNavDots' is 7, don't allow this: 'o X o o o'
                    // Instead show as this then: 'o X o o o o o'.
                    if (translateX > 0)
                        translateX = 0;

                    this.dotNav.style.transform = `translateX(${translateX}px)`;
                }
            };

            slider?.addEventListener("itemshow", (e: any): void =>
            {
                // Get and set correct UIkit slide index.
                if (e.detail && e.detail[0])
                    shiftDotnav(e.detail[0].index);
            });

            // Set first dot as active when loading page.
            shiftDotnav(0);
        }
    }
}

function initSliderDotNavEvents()
{
    const sliders = document.querySelectorAll(".c-slider");

    if (sliders)
    {
        sliders.forEach((el: HTMLElement) =>
        {
            const navHolder = el.querySelector(".c-overflow-nav__holder") as HTMLElement;

            if (navHolder)
                new dotNavSlider(navHolder, el);
        });
    }
}
